exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".NotFound{padding-top:100px;text-align:center}", "", {"version":3,"sources":["C:/Users/James/Documents/InteractiveStories/interactive-stories-website/src/containers/NotFound.css"],"names":[],"mappings":"AAAA,UACE,kBAAmB,AACnB,iBAAmB,CACpB","file":"NotFound.css","sourcesContent":[".NotFound {\r\n  padding-top: 100px;\r\n  text-align: center;\r\n}\r\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"minimize":true,"sourceMap":true}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/containers/NotFound.css
// module id = 853
// module chunks = 7